import React from 'react';
import { Icon } from '../../../icons/icons';

const PaymentTextarea = ({ nameplaceholder, idFocus, name, icon }) => {

    return (
        <div className='border py-3 px-4 flex justify-center items-center gap-x-7'>
            <label htmlFor={idFocus} className='font-semibold text-[12px] sm:text-[16px] w-[34%] sm:w-[30%]'>{nameplaceholder}</label>
            <div className="flex items-center w-full">
                <span className='bg-[#f8f9fa] py-2 px-[0.75rem] rounded-l border'>
                    <Icon name={icon} />
                </span>
                <textarea type="text" name={name} className="border rounded-r w-full leading-5 px-3 resize-none placeholder:text-black" id={idFocus} />
            </div>
        </div>
    );
};

export default PaymentTextarea;